module.exports = __webpack_public_path__ + "img/liebiao.07618c67.png";